<template>
  <v-data-table
    :headers="headers"
    :items="dataset"
    :search="search"
    sort-by="start_date"
    sort-desc
    :items-per-page="3"
    :footer-props="{
      itemsPerPageOptions: [-1, 50, 100],
    }"
    :hide-default-footer="expanded2"
    :expanded.sync="expanded"
    show-expand
  >
    <template #[`item.data-table-expand`]="{ expand, isExpanded, item }">
      <v-icon v-if="item.enlargements && item.enlargements.length > 0" @click="expand(!isExpanded)">
        {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
      </v-icon>
      <v-spacer v-if="expanded2" />
    </template>

    <template #[`header.status`]="{ header }">
      <TableFilter
        v-model="tableFilters.status"
        :items="contracts"
        :header="header"
      />
      {{ header.text }}
    </template>

    <template #[`item.number`]="{ item }">
      <LinkContract :contract="item.contract" />
    </template>

    <template #[`item.content`]="{ item }">
      <ContentSnippet v-if="$page.props.user.permissions.offer.nwt_view" :contract="item.content" />
      <div v-else>
        {{ item.content }}
      </div>
    </template>

    <template #[`item.contract.invoiceFlag`]="{ item }">
      <InvoicedSnippet :flag="item.contract.invoiceFlag" />
    </template>

    <template #[`item.created_at`]="{ item }">
      {{ getDateString(item.created_at) }}
    </template>

    <template #[`item.end_date`]="{ item }">
      {{ getDateString(item.end_date) }}
    </template>
    <template #[`item.start_date`]="{ item }">
      {{ getDateString(item.start_date) }}
    </template>

    <template #[`item.updated_at`]="{ item }">
      <span>{{ getDateString(item.updated_at) }}</span>
    </template>

    <template #[`item.expected_completion_at`]="{ item }">
      <span>{{
        item.expected_completion_at
          ? getDateString(item.expected_completion_at)
          : null
      }}</span>
    </template>

    <template #[`item.turnover`]="{ item }">
      {{
        item.turnover
          ? new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
          }).format(item.turnover)
          : null
      }}
    </template>

    <template #expanded-item="{ headers: expanedheaders, item: expandedItem }">
      <td :colspan="expanedheaders.length" class="elevation-0 ">
        <IndexTable
          :contracts="expandedItem.enlargements"
          :expanded2="true"
        />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import TableFilter from '@/Components/Customer/Offers/TableFilter'
import ContentSnippet from '@/Components/Offers/Snippets/ContentSnippet'
import LinkContract from '@/Components/Contract/Snippets/LinkContract'
import InvoicedSnippet from '@/Components/Contract/Snippets/InvoicedSnippet'
import { formattedDateString } from '@/plugins/formatDate.js'
export default {
   name: 'IndexTable',
   components: {
      TableFilter,
      ContentSnippet,
      LinkContract,
      InvoicedSnippet
   },
   props: {
      contracts: {
         type: Array,
         required: true,
      },
      expanded2: {
         type: Boolean,
         required: false,
         default: false
      },
      search: {
         type: String,
         required: false,
         default: '',
      }
   },
   data () {
      return {
         headers: [
            {
               text: 'Inhalt',
               value: 'offerData.content',
               width: '410px'
            },
            {
               text: 'Debitor',
               value: 'debitor.name',
               width: '410px'
            },
            {
               text: 'Vertragsnummer',
               value: 'number',
               width: '220px',
            },
            {
               text: 'AngebotsNr',
               value: 'contract.offer_id',
            },
            { text: 'gesammt Umsatz', value: 'turnover', width: '100px' },
            { text: 'Startdatum', value: 'start_date', width: '100px' },
            { text: 'Laufzeit', value: 'months', width: '25px' },
            { text: 'Enddatum', value: 'end_date', width: '100px' },
            { text: 'Restlaufzeit', value: 'remaining' },
            { text: 'Erstelldatum', value: 'created_at' },
            { text: 'Invoice', value: 'contract.invoiceFlag', sortable: false }
         ],
         tableFilters: {
            status: [],
            source: [],
         },
         expanded: [],
      }
   },
   computed: {
      dataset () {
         const sets = []
         this.contracts.forEach(function (val) {
            sets.push(val)
         })
         return sets
      }
   },
   methods: {
      getDateString (dateVal) {
         return formattedDateString(dateVal)
      },
      monthDiff (dateFrom, dateTo) {
         dateFrom = new Date(Date.parse(dateFrom))
         dateTo = new Date(Date.parse(dateTo))
         return dateTo.getMonth() - dateFrom.getMonth() +
          (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
      }
   }
}
</script>

  <style>
  </style>
